export default __webpack_public_path__ + "static/media/CustomNew.e874f731.png";